import React from "react";

import { Icon, Header, Menu } from "semantic-ui-react";

import BasicSettingsView from "./settings/BasicSettingsView";
import BankSettingsView from "./settings/BankSettingsView";
import BillingSettingsView from "./settings/BillingSettingsView";
import DataImportExportView from "./settings/DataImportExportView";

import RouteMenuItem from "../../components/RouteMenuItem";

import { isOwner } from "../../util/capability";

import { Route, Redirect, Switch } from "react-router-dom";

import { connect } from "react-redux";

const SettingsMenu = () => {
  return (
    <Menu fluid widths={isOwner() ? 4 : 1}>
      <RouteMenuItem exact url="/settings/basic">
        Basic Settings
      </RouteMenuItem>
      {isOwner() && [
        <RouteMenuItem key={"settings-1"} url="/settings/banks">
          Banks
        </RouteMenuItem>,
        <RouteMenuItem key={"settings-2"} url="/settings/billing">
          Billing + Plans
        </RouteMenuItem>,
        <RouteMenuItem key={"settings-3"} url="/settings/data">
          Data Import + Export
        </RouteMenuItem>
      ]}
    </Menu>
  );
};

const SettingsView = props => {
  return (
    <div>
      <Header as="h2">
        <Icon name="settings" />
        <Header.Content>
          Organization Settings
          <Header.Subheader>
            Manage {props.organizationName}'s settings
          </Header.Subheader>
        </Header.Content>
      </Header>
      <SettingsMenu />
      <div style={{ marginTop: "2em" }}>
        <Switch>
          <Route exact path="/settings/basic" component={BasicSettingsView} />
          {isOwner() && [
            <Route
              path="/settings/banks"
              component={BankSettingsView}
              key="settings-route-1"
            />,
            <Route
              path="/settings/billing"
              component={BillingSettingsView}
              key="settings-route-2"
            />,
            <Route
              path="/settings/data"
              component={DataImportExportView}
              key="settings-route-3"
            />
          ]}
          <Route
            path="/settings"
            component={() => <Redirect to="/settings/basic" />}
          />
        </Switch>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  organizationName: state.organization.name
});

export default connect(mapStateToProps)(SettingsView);



// WEBPACK FOOTER //
// ./frontend/src/views/pages/SettingsView.js